<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>快捷付薪</a-breadcrumb-item>
      <a-breadcrumb-item>批量付薪</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 页面内容 -->
    <div class="page-content">
      <a-steps class="steps" :current="current">
        <a-step title="上传名单" />
        <a-step title="确认付薪信息" />
        <a-step title="完成"/>
      </a-steps>
      <div class="step-content">
        <!-- 第一步-上传 -->
        <div class="step-0-box" v-if="current === 0">
          <a-form-model
            ref="ruleForm"
            :model="model"
          >
            <a-form-model-item
              label="合作项目"
              prop="project_id"
              :rules="{ required: true, message: '请选择合作项目', trigger: 'blur' }"
            >
              <!-- 选择器 -->
              <a-select v-model="model.project_id" :getPopupContainer="getPopupContainer" placeholder="请选择" style="width: 640px">
                <a-select-option v-for="item in projectList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="上传名单"
              prop="file"
              :rules="{ required: true, message: '请上传名单', trigger: 'blur' }"
            >
              <a-upload-dragger
                accept=".xlsx, .xsl"
                :showUploadList="false"
                :beforeUpload="beforeUpload"
              >
                <!-- 自定义上传组件 -->
                <slot name="up-slot">
                  <!-- icon -->
                  <p class="ant-upload-drag-icon">
                    <!-- 上传 icon -->
                    <slot name="up-icon"><a-icon type="inbox" /></slot>
                  </p>
                  <!-- 文案 -->
                  <p class="ant-upload-text">
                    <!-- 上传文案 -->
                    <slot name="up-title">点击或将模板文件拖拽到这里上传</slot>
                  </p>
                  <!-- 提示文案 -->
                  <p class="ant-upload-hint" style="margin-top: 16px">
                    <!-- 上传提示文案 -->
                    <slot name="up-hint">
                      请严格按照模板填写数据
                      <a style="margin-left: 8px" @click.stop="downLoadTemplate">下载模板</a>
                    </slot>
                  </p>
                </slot>
              </a-upload-dragger>
              <!-- 自定义显示文件 -->
              <div class="file-list" v-if="file">
                <div>
                  <a-icon type="paper-clip" />
                  {{ file.name }}
                </div>
                <a-icon type="delete" @click="clearFile" />
              </div>
            </a-form-model-item>
          </a-form-model>
          <div style="text-align: center">
            <a-button type="primary" @click="importExcelCheck">下一步</a-button>
          </div>
        </div>
        <!-- 第二步：确认付薪 -->
        <div class="step-1-box" v-if="current === 1">
          <a-table
            :columns="columns"
            :dataSource="dataSource"
            :rowKey="record => record.number"
            :pagination="false"
          >
            <!-- 金额 -->
            <template slot="money" slot-scope="text">
              {{ division(text, 100) }}
            </template>
            <!-- 其他信息 -->
            <template slot="is_auth" slot-scope="text">
              <span v-if="text">一致</span>
              <div v-else>
                <a-tooltip>
                  <template slot="title">
                    该用户尚未实名认证，无法校验，请跟对方再次确认合拍号
                  </template>
                  <span style="color: orange">
                    未实名 <a-icon type="exclamation-circle" theme="filled" />
                  </span>
                </a-tooltip>
              </div>
            </template>
          </a-table>
          <div class="total-info">共计 <span>{{ totalInfo.count }}</span> 笔，账户总支出 <span>{{ totalInfo.total_pay }}</span> 元</div>
          <div class="btns">
            <a-button type="primary" @click="onCommit">提交</a-button>
            <a-button @click="preStep">上一步</a-button>
          </div>
        </div>
        <!-- 统一底部 -->
        <a-alert
          message="灵工付薪说明："
          type="info"
          style="margin-top: 40px"
        >
          <div slot="description">
            <p v-html="description" style="white-space: pre-wrap;"></p>
          </div>
        </a-alert>
      </div>
    </div>
    <!-- 确认付薪弹窗 -->
    <ConfirmModal ref="ConfirmModal" @success="preStep" />
  </div>
</template>

<script>
import Pub from '@/utils/public'
import Upload from '@/components/Upload'
import { DOWLOAD_FILE_URL } from '@/utils/download'
import { getProjectAll, importExcelCheck } from '@/api/request'
import ConfirmModal from './components-batch-pay/ConfirmModal'

const columns = [
  {
    title: '编号',
    dataIndex: 'number',
    key: 'number'
  },
  {
    title: '合拍号',
    dataIndex: 'user_id',
    key: 'user_id'
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '姓名校验',
    dataIndex: 'is_auth',
    key: 'is_auth',
    scopedSlots: { customRender: 'is_auth' }
  },
  {
    title: '支付金额',
    dataIndex: 'money',
    key: 'money'
  },
  {
    title: '服务费承担人',
    dataIndex: 'payer',
    key: 'payer'
  },
  {
    title: '服务费',
    dataIndex: 'fee',
    key: 'fee'
  },
  {
    title: '收款人到账',
    dataIndex: 'total_get',
    key: 'total_get'
  }, 
]

export default {
  components: {
    ConfirmModal,
    Upload
  },
  data () {
    return {
      columns,
      description: '1、合拍号是合拍平台每个账号的唯一标识，付款之前先邀请收款人在“合拍创薪”小程序注册账号。\n2、请务必跟对方确认合拍号无误。若因合拍号错误导致财产损失由付款人自己承担。\n3、服务费包含了我们为您开具6%的增值税专用发票，以及我们为收款人在国家税务机构缴纳个人所得税。\n4、根据你们跟收款人的协商情况，选择服务费承担人。',
      // 步骤
      current: 0,
      // 合作中的项目列表
      projectList: [],
      // 表单数据
      model: {
        project_id: undefined,
      },
      // 表单-上传的文件
      file: undefined,
      // 表格文件对应的数据列表
      dataSource: [],
      // 费率
      fee: undefined,
      // 总计信息
      totalInfo: {},
      // 设置一个临时的值，存放 project_id，第二步以后使用这个项目 id 
      projectId: undefined
    }
  },
  created () {
    // 获取合作项目列表
    this.getProjectAll()
  },
  methods: {
    // 重新指定渲染控件
    getPopupContainer (triggerNode) {
      return triggerNode.parentNode
    },
    // 获取合作项目列表
    getProjectAll () {
      getProjectAll().then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          this.projectList = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 下载模板
    downLoadTemplate () {
      const url = location.origin + '/vue-assets/pay_for_actors.xlsx'
      DOWLOAD_FILE_URL(url, '合拍创薪批量付薪模板.xlsx')
    },
    // 上传前
    beforeUpload (file, fileList) {
      if (this.file) {
        // 一次只接收一个文件
        this.file = undefined
      }
      this.$formJson(file, (code, sheets) => {
        if (code === 0) {
          // 取出数据，过滤掉空行
          const sheet = sheets[0].list.filter(item => item.length > 0)
          // 初始化表头
          let head = []
          // 定义验证结果
          let result = true
          // 为下面的 for 循环命名
          checkLoop:
          for (let index = 0 ; index < sheet.length; index ++) {
            if (index === 0) {
              // 设置表头
              head = sheet[index]
            } else {
              // 内层循环（循环次数用 item.lenght会造成遗漏，所以用表头的字段长度 head.length）
              for (let i = 0; i < head.length; i++) {
                // 不是备注（i !== 4）的列，校验必填 
                if (!sheet[index][i] && i !== 4) {
                  this.$error({
                    title: `第${index + 1}行，未填写${head[i]}`,
                    content: '请补充后再提交',
                  })
                  result = false
                  // 跳出 checkLoop 循环
                  break checkLoop
                }
                // 金额的列，校验数字格式：必须大于0，支持2位小数点
                if (i === 2) {
                  const money = sheet[index][i]
                  // 正则一： 纯数字
                  const reg1 = /^[0-9]*$/
                  // 正则二：有1-2位小数的数字
                  const reg2 = /^[0-9]+(.[0-9]{1,2})?$/
                  // 如果两个正则都不满足，或者本身是0，给出提示
                  if ((!reg1.test(money) && !reg2.test(money)) || money === '0' || money > 90000) {
                    this.$error({
                      title: `第${index + 1}行，金额格式不正确`,
                      content: '必须大于0且小于90000，支持2位小数点',
                    })
                    result = false
                    // 跳出 checkLoop 循环
                    break checkLoop
                  }
                }
                // 服务费承担人的列，校验内容：付款人 或 收款人
                if (i === 3) {
                  const people = sheet[index][i]
                  if (people !== '付款人' && people !== '收款人') {
                    this.$error({
                      title: `第${index + 1}行，服务费承担人格式不正确`,
                      content: '可填项：付款人、收款人',
                    })
                    result = false
                    // 跳出 checkLoop 循环
                    break checkLoop
                  }
                }
              }
            }
          }
          if (result) {
            // 暂存文件
            this.file = file
          }
        }
      })
    },
    // 清空暂存文件
    clearFile () {
      this.file = undefined
    },
    // 点击下一步，后端验证表格数据正确性
    importExcelCheck () {
      const { file, model } = this
      // 校验合作项目、名单
      if (!model.project_id) {
        return this.$message.error('请选择合作项目')
      }
      if (!file) {
        return this.$message.error('请上传名单')
      }
      importExcelCheck({
        project_id: model.project_id,
        myfile: file
      }).then(res => {
        const { code, data, message } = res
        if (code === 0) {
          // 验证通过后，进入下一步数据展示
          this.current = 1
          // 上一步表格的数据带过来反显
          data.excel_data.forEach((item, index) => {
            item.number = index + 1
          })
          this.dataSource = data.excel_data
          // 处理服务费率
          let cols = this.columns
          cols.forEach(item => {
            if (item.key === 'fee') {
              item.title = `服务费（${data.fee_v}%）`
            }
          })
          this.fee = data.fee_v
          // 总计信息
          this.totalInfo = data.import_count
          // 使用临时的值存放项目id，用于最后一步支付
          this.projectId = this.model.project_id
          // 并且清空上一步的内容！
          this.model = {
            project_id: undefined
          }
          this.file = undefined
        } else {
          // 合拍号不存在
          if (code === -101) {
            this.$error({
              title: message,
              content: '请联系演员确认修改后再提交。'
            })
          }
          // 余额不足
          else if (code === -200) {
            this.$error({
              title: message,
              content: '请先充值。'
            })
          }
          // 已激活店铺不允许付薪
          else if (code === 5000) {
            this.$error({
              title: message,
              content: '只可以向未激活店铺的合拍号付薪'
            })
          }
          // 其他
          else {
            this.$error({
              title: message,
              content: '请复查后再提交。'
            })
          }
        }
      })
    },
    // 上一步
    preStep () {
      this.current = 0
      this.dataSource = []
      this.fee = undefined
      this.totalInfo = {}
      this.projectId = undefined
    },
    // 提交
    onCommit () {
      const info = {
        projectId: this.projectId,
        dataSource: this.dataSource,
        totalInfo: this.totalInfo
      }
      this.$refs['ConfirmModal'].showModal(info)
    }
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
  .page-content {
    padding: 36px 0 20px;
    .steps {
      width: 80%;
      margin-left: 10%;
    }
    .step-content {
      padding: 30px 16px;
      .step-0-box {
        .ant-form-item {
          display: flex;
          justify-content: center;
        }
        /deep/ .ant-upload-drag {
          width: 640px;
          height: 320px;
        }
        .anticon-inbox {
          font-size: 64px;
        }
        .file-list {
          padding: 0 6px;
          margin-top: 2px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &:hover {
            background: #f7f7f7;
          }
        }
      }
      .step-1-box {
        .total-info {
          margin-top: 16px;
          text-align: center;
          span {
            font-weight: bold;
            font-size: 16px;
          }
        }
        .btns {
          margin-top: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          .ant-btn-primary {
            margin-right: 10px;
          }
        }
      }
      .ant-alert-info  {
        color: rgba(0, 0, 0, 0.4);
        /deep/ .ant-alert-message {
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}
</style>